module.exports = __webpack_public_path__ + "static/tennis-5fbec0a58235c213cbfec2221244401a.mp4";